var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimaryRiyal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_3693)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_388_3693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.529297H0V28.4704H25V0.529297Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_388_3693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5571 25.2823C15.111 26.2715 14.8161 27.345 14.7031 28.4707L24.1439 26.4638C24.59 25.4749 24.8847 24.4012 24.9979 23.2754L15.5571 25.2823Z",
    fill: "#C4D26E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.146 20.4512C24.5921 19.4622 24.887 18.3885 25 17.2628L17.6459 18.8268V15.8201L24.1458 14.4388C24.5919 13.4498 24.8868 12.3761 24.9998 11.2504L17.6457 12.8131V1.99998C16.5189 2.63268 15.5181 3.47488 14.7046 4.46831V13.4385L11.7634 14.0636V0.529297C10.6366 1.16178 9.63581 2.0042 8.8223 2.99763V14.6886L2.24149 16.087C1.79537 17.0759 1.50026 18.1497 1.38706 19.2754L8.8223 17.6953V21.4818L0.853986 23.1751C0.407867 24.164 0.112975 25.2377 0 26.3635L8.3406 24.591C9.01956 24.4498 9.60312 24.0484 9.98252 23.496L11.5121 21.2282C11.6709 20.9936 11.7634 20.7103 11.7634 20.4056V17.0702L14.7046 16.445V22.4585L24.146 20.4512Z",
    fill: "#C4D26E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_3693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryRiyal);
export default __webpack_public_path__ + "static/media/primaryRiyal.7094a70ff978e78d50667f487264104a.svg";
export { ForwardRef as ReactComponent };